module.exports = __webpack_public_path__ + "img/base.60ca630c.svg";